import { render, staticRenderFns } from "./SalePage.vue?vue&type=template&id=7c7e4fd0&scoped=true&"
import script from "./SalePage.vue?vue&type=script&lang=js&"
export * from "./SalePage.vue?vue&type=script&lang=js&"
import style0 from "./SalePage.vue?vue&type=style&index=0&id=7c7e4fd0&scoped=true&lang=scss&"
import style1 from "./SalePage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7e4fd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VDialog,VPagination,VTextField})
